// Cache de propiedades para el catálogo público.
// Persiste en localStorage para que al recargar/volver al sitio el catálogo
// aparezca al instante (stale-while-revalidate: se muestra lo cacheado y se
// refresca en segundo plano). Se invalida cuando el corredor guarda cambios.

const CLAVE = 'fp_cache_propiedades';
const TTL = 5 * 60 * 1000; // 5 minutos: dentro de esto NO se vuelve a pedir a Firestore

// Respaldo en memoria por si localStorage no está disponible (modo privado, etc.)
let _mem = null;

function leer() {
  if (_mem) return _mem;
  try {
    const raw = localStorage.getItem(CLAVE);
    if (!raw) return null;
    _mem = JSON.parse(raw);
    return _mem;
  } catch {
    return null;
  }
}

// Devuelve las propiedades cacheadas aunque estén vencidas (para pintar al instante).
// null solo si nunca se cacheó nada.
export function getCachePropiedades() {
  const c = leer();
  return c?.props || null;
}

// true si el caché todavía es "fresco" (no hace falta refetch).
export function cacheEsFresco() {
  const c = leer();
  return !!c && Date.now() - c.tiempo < TTL;
}

export function setCachePropiedades(props) {
  const dato = { props, tiempo: Date.now() };
  _mem = dato;
  try {
    localStorage.setItem(CLAVE, JSON.stringify(dato));
  } catch {
    // Quota excedida o storage no disponible: queda solo el respaldo en memoria.
  }
}

export function invalidarCachePropiedades() {
  _mem = null;
  try { localStorage.removeItem(CLAVE); } catch { /* noop */ }
}
